<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Pending Signoffs</h4>
      <p>Click on Demand ID to view demand details and sign off</p>
    </div>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular #agGrid
                     id="SignoffGrid"
                     style="width: 100%; height: 540px"
                     class="ag-theme-balham"
                     [gridOptions]="gridOptions"
                     [rowData]="rowData"
                     [pagination]="true"
                     (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
